import { UserPermission } from "../../types/apiTypes";
import Page from "../Page";
import UserManagmentList from "./UserManagmentList";

interface Props {
  accountPermission: UserPermission;
}

const UserManagment = ({ accountPermission }: Props) => (
  <Page title="Benutzerverwaltung">
    <UserManagmentList accountPermission={accountPermission} />
  </Page>
);

export default UserManagment;
